import lazysizes from 'lazysizes';

/**
 * Plugin for initializing `lazysizes` library.
 */
export default defineNuxtPlugin({
  name: 'lazysizes',
  parallel: true,
  setup() {
    /**
     * The `lazysizes.cfg` object is only created after a few ticks, which would override
     * any configuration values we set immediately. We use a watcher to ensure our
     * configuration values are applied after the cfg object is available.
     *
     * @see https://github.com/aFarkas/lazysizes?tab=readme-ov-file#js-api---options
     */
    watchOnce(
      () => lazysizes.cfg,
      () => {
        lazysizes.cfg.loadMode = 0;
        lazysizes.cfg.expFactor = 0.4;
        lazysizes.cfg.hFac = 1;
      },
      { immediate: true },
    );
  },
});
